import React from 'react';
import { Radio, Text, TextArea } from 'v3/components';
import CheckBox from 'components/CheckBox';
import { getSelectedChoiceIds } from 'v3/services/cteQuestionnaire';
import {
  Subquestions,
  SubquestionItem,
  SubquestionLabel,
  Wrapper,
} from './styles';

function Field({ question, value, onChange, error, readOnly }) {
  if (question.type === 'TEXT') {
    return (
      <TextArea
        label={question.question}
        value={value || ''}
        onChange={event => onChange(event.target.value)}
        error={error}
        disabled={readOnly}
      />
    );
  }

  if (question.type === 'RADIO') {
    return (
      <>
        <Text type="label" color="dark" weight="500">
          {question.question}
        </Text>
        <Radio.Group
          value={value || ''}
          onChange={({ target }) => onChange(String(target.value))}
          disabled={readOnly}
        >
          {(question.choices || []).map(choice => (
            <Radio key={choice.id} value={String(choice.id)}>
              <Text type="regular" color="dark">
                {choice.label}
              </Text>
            </Radio>
          ))}
        </Radio.Group>
        {!!error && (
          <Text color="error" type="little">
            {error}
          </Text>
        )}
      </>
    );
  }

  if (question.type === 'CHECKBOX') {
    const selected = Array.isArray(value) ? value : [];

    const toggle = choiceId => {
      const id = String(choiceId);
      const next = selected.includes(id)
        ? selected.filter(existing => existing !== id)
        : [...selected, id];
      onChange(next);
    };

    return (
      <>
        <Text type="label" color="dark" weight="500">
          {question.question}
        </Text>
        {(question.choices || []).map(choice => (
          <CheckBox
            key={choice.id}
            label={choice.label}
            checked={selected.includes(String(choice.id))}
            onChange={() => toggle(choice.id)}
            disabled={readOnly}
          />
        ))}
        {!!error && (
          <Text color="error" type="little">
            {error}
          </Text>
        )}
      </>
    );
  }

  if (question.type === 'PHOTO') {
    return (
      <>
        <Text type="label" color="dark" weight="500">
          {question.question}
        </Text>
        <div>
          <Text type="little" color="placeholder">
            Pergunta do tipo foto — ainda não é possível responder por aqui.
          </Text>
        </div>
      </>
    );
  }

  return null;
}

export default function QuestionField({
  question,
  values,
  errors,
  onAnswerChange,
  readOnly = false,
}) {
  const value = values[question.id];
  const selectedChoiceIds = getSelectedChoiceIds(question, value);
  const visibleSubquestions = (question.subquestions || []).filter(sub =>
    (sub.triggeredByChoiceIds || []).some(choiceId =>
      selectedChoiceIds.has(String(choiceId))
    )
  );

  return (
    <Wrapper>
      <Field
        question={question}
        value={value}
        error={errors[question.id]}
        onChange={next => onAnswerChange(question.id, next)}
        readOnly={readOnly}
      />
      {visibleSubquestions.length > 0 && (
        <Subquestions>
          {visibleSubquestions.map(sub => (
            <SubquestionItem key={sub.id}>
              <SubquestionLabel>Subpergunta</SubquestionLabel>
              <QuestionField
                question={sub}
                values={values}
                errors={errors}
                onAnswerChange={onAnswerChange}
                readOnly={readOnly}
              />
            </SubquestionItem>
          ))}
        </Subquestions>
      )}
    </Wrapper>
  );
}
